import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import BgImg from "../../../images/case-studies/animal-debt/animal-debt-back-banner.webp";

function Banner() {
  return (
    <section
      className="animal-case-banner"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={9}
            xxl={8}
            className="m-auto text-center"
          >
            <h1 style={{ color: "#000" }}>
              <span style={{ color: "#007F6E" }}>Animal Debt Disaster</span>: A
              Ridiculously Funny Puzzle Game with Viral Potential and
              Multi-Million Dollar Gains
            </h1>
            <p>
              When absurdity meets creativity, hilarity follows. Animal Debt
              Disaster takes gaming to a new level of fun and ridiculousness.
            </p>
            <Link
              to="/contact"
              className="border_btn animal-case-btn"
              aria-label="TekRevol Contact"
            >
              Let’s Build Your Game Now
            </Link>
            <div className="animla-banner-img">
              <StaticImage
                src="../../../images/case-studies/animal-debt/Animal-Debt.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={1397}
                height={968}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Banner;
